module.exports = __webpack_public_path__ + "img/sg_feature1.e0091760.jpg";